module.exports = __webpack_public_path__ + "img/dtac.c3e3d28b.png";